import { render } from "./AsRenews.vue?vue&type=template&id=21a3e666&scoped=true&ts=true"
import script from "./AsRenews.vue?vue&type=script&lang=ts"
export * from "./AsRenews.vue?vue&type=script&lang=ts"

import "./AsRenews.vue?vue&type=style&index=0&id=21a3e666&lang=scss&scoped=true"

import exportComponent from "/home/gitlab-runner/builds/q5ZtNtxNr/0/anyclass/platform-frontend/web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21a3e666"]])

export default __exports__